import { DocumentCategory, DocumentPhase } from '../constants'

export const CATEGORIES_TO_SHOW = [
  DocumentCategory.business_entity,
  DocumentCategory.business_affiliate,
  DocumentCategory.business_use_of_proceeds,
  DocumentCategory.business_financial_and_underwriting,
  DocumentCategory.business_location,
  DocumentCategory.business_franchise,
  DocumentCategory.business_insurance,
  DocumentCategory.business_sba_forms_and_loan,
  DocumentCategory.business_bank_search,
  DocumentCategory.business_funding,
  DocumentCategory.business_uncategorized,
]

export const PHASES_TO_SHOW = [DocumentPhase.main, DocumentPhase.financials]

export const NOT_FULL_WIDTH_INPUTS = 'calc(50% - 0.5rem)'
